export enum Lang {
  UK = 'uk',
  EN = 'en',
}
